import { type FC, memo } from 'react';
import cn from 'classnames';

import { playSound } from '@/common/lib/soundEffect';
import { StringMain } from '@/components/Typography/Typography';
import { setRollPower } from '@/redux/reducers/diceGameReducer';
import { useAppDispatch } from '@/redux/store';

interface RollPowerItemmProps {
  value: number;
  isActive: boolean;
  disabled: boolean;
}

const RollPowerItem: FC<RollPowerItemmProps> = memo(
  ({ value, isActive, disabled }) => {
    const dispatch = useAppDispatch();
    const handleClick = (): void => {
      if (![1, 2, 5].includes(value)) return;
      playSound('plants/percentage-selection');
      dispatch(setRollPower(value as 1 | 2 | 5));
    };

    return (
      <button
        disabled={disabled}
        onClick={handleClick}
        className={cn(
          'p-px rounded-full transition-all',
          isActive && 'bg-button-green-gradient',
          disabled && 'opacity-40',
        )}
      >
        <div
          className={cn(
            'flex items-center rounded-full justify-center size-full transition-all bg-surface',
            isActive && 'from-[#61A323]/20 to-[#3B700C]/20 bg-gradient-to-b',
          )}
        >
          <StringMain className={cn(isActive && '!text-[#82E024]')}>
            x{value}
          </StringMain>
        </div>
      </button>
    );
  },
);

export default RollPowerItem;
